var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLine3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 139,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#F4C341",
  strokeLinecap: "round",
  strokeOpacity: 0.3,
  strokeWidth: 4,
  d: "m120 2 17 13.5M19 2 2 15.5"
})));
export { SvgLine3 as ReactComponent };
export default __webpack_public_path__ + "202a5bda5cdf6b490384d25a20a07b80.svg";